import Gradient from "../../../images/SVG/Finder/Gradient.svg?raw";
import Factory from "../../../images/SVG/Finder/Factory.svg?raw";
import RoadHorizon from "../../../images/SVG/Finder/RoadHorizon.svg?raw";
import PlusCircle from "../../../images/SVG/Finder/PlusCircle.svg?raw";
import CirclesThreePlus from "../../../images/SVG/Finder/CirclesThreePlus.svg?raw";

export function useStep2(state) {
    const index = 2;
    const title = "What are your environmental targets and constraints?";
    let questions = [];

    const contactParagraph = `<p>Please <a href="${state.ContactLink}">contact</a> our Stormwater Representative at <a href="tel:${state.ContactNumber}">0800 STORMWATER</a></p>`;

    // Reset messages
    state.messageTitle = "";
    state.message = "";
    state.messageTitle2 = "";
    state.message2 = "";
    state.baselineMessage = "";

    if (state.type === "Private") {

        if (state.location === "") {
            console.error(
                "You shouldn't be loading step 2 without location data.",
            );
            return
        }

        if (state.location != "" && state.use === "") {
            state.use = "Standard";
        }

        questions.push({
            question: "What is the site use?",
            name: "use",
            model: state.use,
            options: [
                {
                    icon: Gradient,
                    value: "Standard",
                    info: "Residential, Commercial Developments, Carparks, Local roads etc"
                },
                {
                    icon: Factory,
                    value: "Industrial",
                },
                {
                    icon: RoadHorizon,
                    value: "State Highway",
                },
            ],
        });

        if (state.use === "Standard") {
            if (state.location === "Auckland") {
                questions.push({
                    question: "What are your environmental targets?",
                    model: null,
                    name: "target",
                    options: [
                        {
                            value: "GD01 Level treatment",
                        },
                        {
                            value: "Detention & Retention Requirement",
                        },
                        {
                            value: "SMAF Zones",
                        },
                        {
                            value: "BioFiltration Only",
                        },
                    ],
                });

                if (
                    state.target === "SMAF Zones" ||
                    state.target === "GD01 Level treatment"
                ) {
                    questions.push({
                        question: "Any constraints?",
                        model: null,
                        name: "constraint",
                        options: [
                            {
                                value: "None",
                            },
                            {
                                value: "Depth Constraints",
                            },
                            {
                                value: "Hydraulic Constraints",
                            },
                        ],
                    });
                }

                if (
                    state.target === "SMAF Zones" &&
                    (state.constraint === "None")
                ) {
                    state.baselineMessage = `<p>Filterra system has Filterra with Retention vault option, however, this is a custom solution.</p>`;
                    state.baselineMessage =
                        state.baselineMessage + contactParagraph;
                }

                if (
                    state.target === "GD01 Level treatment" &&
                    state.constraint === "Hydraulic Constraints" ||
                    state.target === "SMAF Zones" &&
                    state.constraint === "Hydraulic Constraints"
                ) {
                    state.baselineMessage = `<p>StormFilter system has StormFilter low hydraulic drop option, however, this is a custom solution.</p>`;
                    state.baselineMessage =
                        state.baselineMessage + contactParagraph;
                }
            } // End of auckland

            if (state.location === "Christchurch") {
                questions.push({
                    question: "What are your environmental targets?",
                    model: null,
                    name: "target",
                    options: [
                        {
                            value: "75% TSS Removal",
                        },
                        {
                            value: "Detention & Retention Requirement",
                        },
                    ],
                });

                if (state.target === "75% TSS Removal") {
                    questions.push({
                        question: "Any constraints?",
                        model: null,
                        name: "constraint",
                        options: [
                            {
                                value: "None",
                            },
                            {
                                value: "Depth Constraints",
                            },
                            {
                                value: "Hydraulic Constraints",
                            },
                        ],
                    });

                    if (state.constraint === "Hydraulic Constraints") {
                        state.baselineMessage = `<p>StormFilter system has StormFilter low hydraulic drop option, however, this is a custom solution.</p>`;
                        state.baselineMessage =
                            state.baselineMessage + contactParagraph;
                    }
                }
            } // End of christchurch

            if (state.location === "Waikato") {
                questions.push({
                    question: "What are your environmental targets?",
                    model: null,
                    name: "target",
                    options: [
                        {
                            value: "75% TSS Removal",
                        },
                        {
                            value: "Detention & Retention Requirement",
                        },
                    ],
                });

                if (state.target === "75% TSS Removal") {
                    questions.push({
                        question: "Any constraints?",
                        model: null,
                        name: "constraint",
                        options: [
                            {
                                value: "None",
                            },
                            {
                                value: "Depth Constraints",
                            },
                            {
                                value: "Hydraulic Constraints",
                            },
                        ],
                    });

                    if (state.constraint === "Hydraulic Constraints") {
                        state.baselineMessage = `<p>StormFilter system has StormFilter low hydraulic drop option, however, this is a custom solution.</p>`;
                        state.baselineMessage =
                            state.baselineMessage + contactParagraph;
                    }
                }
            } // End of waikato

            if (state.location === "Wellington") {
                questions.push({
                    question: "Any constraints?",
                    model: null,
                    name: "target",
                    options: [
                        {
                            value: "None",
                        },
                        {
                            value: "Space Constraints",
                            info: "With approval from council",
                        },
                    ],
                });
            } // End of wellington

            if (state.location === "Canterbury" || state.location === "Other") {
                questions.push({
                    question: "What are your environmental targets?",
                    model: null,
                    name: "target",
                    options: [
                        {
                            value: "75% TSS Removal",
                        },
                        {
                            value: "ANZECC Guideline",
                        },
                        {
                            value: "Green Infrastructure only",
                        },
                        {
                            value: "BIO/GPT",
                        },
                        {
                            value: "Target Visible trash/neutral buoyant material",
                        },
                        {
                            value: "Detention and Retention Requirement",
                        },
                    ],
                });

                if (
                    state.target === "75% TSS Removal" ||
                    state.target === "ANZECC Guideline" ||
                    state.target === "BIO/GPT"
                ) {
                    questions.push({
                        question: "Any constraints?",
                        model: null,
                        name: "constraint",
                        options: [
                            {
                                value: "None",
                            },
                            {
                                value: "Depth Constraints",
                            },
                            {
                                value: "Hydraulic Constraints",
                            },
                        ],
                    });
                }

                if (
                    state.target === "75% TSS Removal" &&
                    state.constraint === "Hydraulic Constraints"
                ) {
                    state.baselineMessage = `<p>StormFilter system has StormFilter low hydraulic drop option, however, this is a custom solution.</p>`;
                    state.baselineMessage =
                        state.baselineMessage + contactParagraph;
                }

                if (
                    state.target === "ANZECC Guideline" // &&
                    // state.constraint != ""
                ) {
                    state.messageTitle = "Information on ANZECC Guidelines";

                    let fileStatement = ''
                    if (state.ANZECCGuidelinesFile) {
                        fileStatement += `<a href="${state.ANZECCGuidelinesFile}" target="_blank" download>Click here to download</a> information on how to apply ANZECC Guideline to Stormwater Discharges.`
                    }

                    state.message = `<p>ANZECC Guidelines has often been mistakenly applied as a discharge limit. ${fileStatement}</p>`;
                    state.message += `<p>Please <a href="${state.ContactLink} "our Stormwater Representative on <a href="tel:${state.ContactNumber}">0800 STORMWATER</a> to discuss our work with other regional councils and example of applying ANZECC guideline to resource consent.</p>`;
                }

                if (
                    state.target ===
                    "Target Visible trash/neutral buoyant material"
                ) {
                    questions.push({
                        question: "Any constraints?",
                        model: null,
                        name: "constraint",
                        options: [
                            {
                                value: "None",
                            },
                            {
                                value: "Hydraulic or Depth Constraints",
                            },
                        ],
                    });
                }
            } // End canterbury
        }

        if (state.use === "Industrial") {
            state.messageTitle =
                "On industrial sites, the types of contaminants in stormwater runoff can vary based on specific activities";
            state.message = `<p>Our stormwater specialists understand these unique challenges and are available to discuss a tailored treatment solution.</p>`;
        }

        if (state.use === "State Highway") {
            state.messageTitle =
                "State Highway has higher sediment load compared to standard catchment. ";

            if (state.location === "Auckland") {
                state.message = `<p>ASM has specification of Treatment train using VortCapture and StormFilter to cater to higher sediment loading from State Highway.</p>`;
            } else {
                state.message = `<p>State Highway has higher sediment load compared to standard catchment. We recommend treatment train approach using pre-treatment device such as Cascade Separator upstream of the primary treatment system StormFilter or Jellyfish to cater to higher sediment loading from State Highway.</p>`;
            }
        }

        if (state.use != "Standard") {
            state.message = state.message + contactParagraph;
        }
    } // PRIVATE END

    if (state.type === "Public") {

        if (state.location === "") {

            state.use = ""

            console.error(
                "You shouldn't be loading step 2 without location data.",
            );
        }

        if (state.use === "") {
            state.use = "New Project";
        }

        questions.push({
            question: "What is the site use?",
            name: "use",
            model: state.use,
            options: [
                {
                    icon: PlusCircle,
                    value: "New Project",
                },
                {
                    icon: CirclesThreePlus,
                    value: "Retrofit Project",
                },
            ],
        });

        questions.push({
            question: "What are your environmental targets?",
            model: null,
            name: "target",
            options: [
                {
                    value: "75% TSS Removal",
                },
                {
                    value: "ANZECC Guideline",
                },
                {
                    value: "Green Infrastructure only",
                },
                {
                    value: "Coarse sediments",
                },
                {
                    value: "Target Visible trash/neutral buoyant material",
                },
                {
                    value: "Pre-Treatment to primary treatment systems",
                },
                {
                    value: "Detention and Retention Requirement",
                },
            ],
        });

        if (state.target === "75% TSS Removal" || state.target === "ANZECC Guideline") {

            questions.push({
                question: "Any constraints?",
                model: null,
                name: "constraint",
                options: [
                    {
                        value: "None",
                    },
                    {
                        value: "Physical Constraints",
                    },
                    {
                        value: "Budget Constraints",
                    },
                    {
                        value: "Depth Constraints",
                    },
                    {
                        value: "Hydraulic Constraints",
                    },
                ],
            });

            if (state.constraint === "Hydraulic Constraints") {

                state.baselineMessage = `<p>StormFilter system has StormFilter low hydraulic drop option, however, this is a custom solution.</p>`;
                state.baselineMessage =
                    state.baselineMessage + contactParagraph;
            }
        }

        if(state.target === "ANZECC Guideline") {

            let fileStatement = ''
            if (state.ANZECCGuidelinesFile) {
                fileStatement += `<a href="${state.ANZECCGuidelinesFile}" target="_blank" download>Click here to download</a> information on how to apply ANZECC Guideline to Stormwater Discharges.`
            }

            state.message = `<p>ANZECC Guidelines has often been mistakenly applied as a discharge limit. ${fileStatement}</p>`;
            state.message += `<p>Please <a href="${state.ContactLink} "our Stormwater Representative on <a href="tel:${state.ContactNumber}">0800 STORMWATER</a> to discuss our work with other regional councils and example of applying ANZECC guideline to resource consent.</p>`;
        }


        if (state.target === "Coarse sediments" || state.target === "Target Visible trash/neutral buoyant material") {

            questions.push({
                question: "Any constraints?",
                model: null,
                name: "constraint",
                options: [
                    {
                        value: "None",
                    },
                    {
                        value: "Depth Constraints",
                    },
                    {
                        value: "Hydraulic Constraints",
                    },
                ],
            });
        }

        if (state.use === "Retrofit Project") {
            state.messageTitle2 = "Information on Retrofit Projects";
            state.message2 = `<p>Retrofitting a treatment system into an existing network can be very challenging and can have many restrictions. </p>`
            if (state.RetrofitProjectFile) {
                state.message2 += `<p><a href="${state.RetrofitProjectFile}" target="_blank" download>Click here to download the file</a> on key considerations required when undertaking a retrofit project. </p>`
            }
            state.message2 += `<p>Stormwater360 can also provide a free consultation, please <a href="${state.ContactLink}">contact</a> our Stormwater Representative on <a href="tel:${state.ContactNumber}">0800 STORMWATER</a> to discuss the retrofit project and review the key considerations in the file in finer detail.</p>`;
        }

    } // PUBLIC END

    // Loop through state and reset / set checked values
    // This is needed for reloading state ( back / next )
    for (const [key, value] of Object.entries(state)) {
        const q = questions.find((q) => q.name === key);

        // Only change options in this step
        if (q !== undefined) {
            q.options.forEach((o) => {
                if (o.checked) {
                    delete o.checked;
                }
            });

            if (value !== "") {
                const o = q.options.find((o) => o.value === value);
                if (o) {
                    o.checked = true;
                }
            }
        }
    }

    return {
        index,
        title,
        questions,
    };
}
